import { PreferredInterestPaymentType } from './PreferredInterestPaymentType';

export const PreferredInterestPaymentTypeOptions = [
    {
        id: PreferredInterestPaymentType.CurrentPayReserve,
        name: 'Current Pay / Reserve',
        shortName: 'Current Pay / Res.',
        sortOrder: 1,
        active: true,
    },
    {
        id: PreferredInterestPaymentType.Accrual,
        name: 'Accrual',
        shortName: 'Accrual',
        sortOrder: 2,
        active: true,
    },
];
